<template>
  <div class="row">
    <div :class="isDeviceLoaded ? 'col-8 p-0 m-0' : 'col-12 p-0 m-0'">
      <div class="h-100">
        <GoogleMap @loadDevice="loadDevice" />
      </div>
    </div>
    <div v-if="isDeviceLoaded" class="col-4 p-0 m-0">
      <div class="row">
        <div class="col-12">
          <canvas id="canvas" style="width: 100%; height: auto"></canvas>
          <button @click="openFullscreen" class="btn btn-primary btn-block w-100 m-0">
            Show Fullscreen Video
          </button>
        </div>
        <div class="col-12">
          <div class="card mt-2 h-100">
            <div class="card-header">
              <div class="row mt-3">
                <div class="col-8">
                  <h4>{{ selectedDevice.device_name }}</h4>
                </div>
                <div class="col-4">
                  <button class="btn btn-sm btn-danger w-100" @click="closeDevice">
                    Close Device
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Device ID: <span>{{ selectedDevice.device_id }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Device Name: <span>{{ selectedDevice.device_name }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Device Status:
                  <strong :class="selectedDevice.status === true
                      ? 'text-success'
                      : 'text-danger'
                    ">{{
    selectedDevice.status === true ? "Online" : "Offline"
  }}</strong>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Device Location:
                  <span>{{ selectedDevice.device_location }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Device Type: <span>{{ selectedDevice.device_type }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  IP Address: <span>{{ selectedDevice.device_ip }}</span>
                </b-list-group-item>
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                  Port: <span>{{ selectedDevice.device_port }}</span>
                </b-list-group-item>
              </b-list-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GoogleMap from "../../components/dashboard/google-map-window.vue";
import { RTSP_BASE_URL } from "../../constants/config";

export default {
  components: {
    GoogleMap,
  },
  data () {
    return {
      selectedDevice: {},
      activeCams: [],
      isDeviceLoaded: false,
    };
  },
  mounted () {
    this.sockets.subscribe("CAMERA_DEVICE", (data) => {
      this.activeCams.push(data.port);
      new JSMpeg.Player(`${RTSP_BASE_URL}:${data.port}`, {
        canvas: document.getElementById("canvas"),
      });
    });
  },
  methods: {
    loadDevice (device) {
      this.selectedDevice = JSON.parse(device);
      this.isDeviceLoaded = true;
      this.$socket.emit(
        "REQUEST:CAMERA_DEVICE",
        JSON.stringify({
          url: `rtsp://admin:Admin1234@${this.selectedDevice.device_ip}:554/Streaming/Channels/101`,
          // url: `rtsp://admin:Admin1234@103.255.232.34:5953/Streaming/Channels/101`,
          command: "start",
        })
      );
    },

    closeDevice () {
      this.isDeviceLoaded = false;
      for (let cam of this.activeCams) {
        this.$socket.emit(
          "REQUEST:CAMERA_DEVICE",
          JSON.stringify({ command: "stop", id: cam })
        );
      }
    },

    openFullscreen () {
      var elem = document.getElementById("canvas");
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    },

    closeFullscreen () {
      try {
        if (document) {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>